import { statusColor as mapStatusColor } from '@/modules/mirrors-redirectors/constants/const'

export default {
  methods: {
    parseGeoList(list) {
      const map = {}
      for (const entry of (list || [])) {
        const dashIndex = entry.indexOf('-')
        const geo = dashIndex !== -1 ? entry.slice(0, dashIndex) : entry
        const device = dashIndex !== -1 ? entry.slice(dashIndex + 1) : 'all'
        if (!map[geo]) map[geo] = { geo, devices: [] }
        if (device === 'all') map[geo].devices = ['all']
        else if (!map[geo].devices.includes('all')) map[geo].devices.push(device)
      }
      return Object.values(map)
    },
    formatGeoList(rules) {
      const result = new Set()
      for (const rule of rules) {
        if (!rule.geo) continue
        if (rule.devices.includes('all')) result.add(rule.geo)
        else for (const device of rule.devices) result.add(`${rule.geo}-${device}`)
      }
      return [...result]
    },
    getGeoForEditableForm({
      scope,
      form,
      blockedRulesState,
      allowedRulesState,
      redirectRulesState,
    }) {
      const gs = scope?.settings?.geo_settings ?? {}
      const rule = gs.default_rule ?? ''
      const isFormScope = scope === form
      const blocked = isFormScope
        ? this.formatGeoList(blockedRulesState)
        : (gs.blocked_geo ?? [])
      const allowed = isFormScope
        ? this.formatGeoList(allowedRulesState)
        : (gs.allowed_geo ?? [])
      const redirect = isFormScope
        ? redirectRulesState.filter(Boolean)
        : (gs.redirect ?? [])

      const blockedRaw = isFormScope ? blockedRulesState : (gs.blocked_geo ?? [])
      const allowedRaw = isFormScope ? allowedRulesState : (gs.allowed_geo ?? [])

      return {
        rule,
        blocked,
        allowed,
        redirect,
        blockedRaw,
        allowedRaw,
        allowedDisplay: (rule === 'deny' || rule === 'redir') ? allowed : [],
        blockedDisplay: (rule === 'allow' || rule === 'redir') ? blocked : [],
      }
    },
    statusColor(status) {
      return mapStatusColor(status)
    },
    getGeo(scope) {
      const gs = scope?.settings?.geo_settings ?? {}
      const rule = gs.default_rule ?? ''

      return {
        rule,
        blocked: gs.blocked_geo ?? [],
        allowed: gs.allowed_geo ?? [],
        redirect: gs.redirect ?? [],
        allowedDisplay: (rule === 'deny' || rule === 'redir') ? (gs.allowed_geo ?? []) : [],
        blockedDisplay: (rule === 'allow' || rule === 'redir') ? (gs.blocked_geo ?? []) : [],
      }
    },
    mirrorLocales(mirror) {
      const hasLocales = mirror?.feature_config?.tags?.includes('locales')
      const projectConfig = this.project_config ?? this.projectConfig
      const source = hasLocales
        ? mirror?.feature_config?.config?.settings?.locales
        : projectConfig?.settings?.locales

      const list = source?.list ?? []
      const def = source?.default

      return def
        ? [def, ...list.filter((l) => l !== def)]
        : list
    },
    targetGeoCountries(mirror) {
      const targetGeo = (mirror?.settings?.target_geo ?? '').trim()
      return targetGeo ? [targetGeo] : []
    },
    goToFeatureConfig() {
      this.$router.push({
        path: '/feature-config',
        query: { entity_id: this.project },
      })
    },
    goToFeatureConfigMirror(mirrorId) {
      if (mirrorId == null || mirrorId === '' || this.project == null) return
      this.$router.push({
        path: '/feature-config',
        query: {
          entity_id: String(this.project),
          mirror_id: String(mirrorId),
        },
      })
    },
  },
}
